<template>
  <div class="prescriptionData main-content">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('prescriptionList.form.basicDetailInfo') }}</div
          >
        </template>
        <div class="collapse-content">
          <base-form
            v-model="topData"
            :options="options"
            ref="topData"
            :rules="topDataRules"
            @input="handleChangeTopData"
            label-width="100px"
          >
          </base-form>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('prescriptionList.form.salesSpecification') }}</div
          >
        </template>
        <!-- <div class="collapse-content">
            <base-form 
              v-model="topData1"
              :options="options1"
              :query='searchForm'
              ref="topData1" 
              :rules="topDataRules" 
              @input="handleChangeTopData"
              label-width="100px">
            </base-form>
        </div> -->
        <div class="collapse-content">
          <vxe-grid
            border
            show-overflow
            resizable
            ref="topTable"
            class="vxe-table-element"
            size="mini"
            align="left"
            :max-height="$store.state.app.tableHeight"
            :auto-resize="true"
            :data="topTableData"
            :columns="columnList"
          >
          </vxe-grid>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('prescriptionList.form.constructionSpecification') }}</div
          >
        </template>
        <div class="collapse-content">
          <base-form
            v-model="topData2"
            :options="options2"
            ref="topData2"
            :rules="topDataRules"
            @input="handleChangeTopData"
            label-width="100px"
          >
          </base-form>
        </div>
      </el-collapse-item>
      <el-collapse-item name="4">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('prescriptionList.form.basicDetailPct') }}</div
          >
        </template>
        <div class="collapse-content">
          <vxe-grid
            border
            show-overflow
            resizable
            ref="table"
            class="vxe-table-element"
            size="mini"
            align="left"
            :auto-resize="true"
            :data="tableData"
            :columns="linkColumnList"
            :edit-rules="rules"
            :toolbar="{}"
            :max-height="$store.state.app.tableHeight"
            :valid-config="{ autoPos: true, message: 'inline' }"
            :edit-config="{ trigger: 'click', mode: 'row' }"
          >
            <template v-slot:buttons>
              <vxe-button
                @click="insertEvent(-1)"
                type="primary"
                icon="el-icon-plus"
                :disabled="buttonStatus()"
                class="vxe-btn-primary"
                >{{ $t('functionBtn.add') }}</vxe-button
              >
              <vxe-button
                @click="handleDelete('table')"
                type="primary"
                icon="el-icon-delete"
                :disabled="buttonStatus()"
                class="vxe-btn-delete"
                >{{ $t('prescriptionList.buttons.delete') }}</vxe-button
              >
            </template>
          </vxe-grid>
        </div>
      </el-collapse-item>
      <el-collapse-item name="5">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('prescriptionList.form.costingCost') }}</div
          >
        </template>
        <div class="collapse-content lableStyle">
          <base-form
            v-model="bottomData"
            :options="bottomOptions"
            ref="bottomData"
            :rules="topDataRules"
            @input="handleChangeBottomData"
            label-width="170px"
          >
          </base-form>
        </div>
      </el-collapse-item>
      <!--附件-->
      <!-- <el-collapse-item name="6">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{this.$t("contractAgency.fileTitle")}}
          </div>
        </template>
        <div class="collapse-content">
          <upload @upload="handleUpload" />
        </div>
      </el-collapse-item> -->
    </el-collapse>
    <footer class="fixed-bottom-btnList">
      <el-button
        class="fixed-bottom-btn"
        type="primary"
        v-hasPermi="['2021050815231124994']"
        :disabled="this.topData.statusFlag === '001' ? true : false"
        @click="handleSave('ZT06')"
        >{{ $t('prescriptionList.buttons.save') }}</el-button
      >
      <el-button
        class="fixed-bottom-btn"
        type="primary"
        v-hasPermi="['2021050815232200363']"
        :disabled="this.topData.statusFlag === '001' ? true : false"
        @click="handleSave('ZT02')"
        >{{ $t('prescriptionList.buttons.submit') }}</el-button
      >
      <el-button
        class="fixed-bottom-btn"
        type="primary"
        v-hasPermi="['2021050815233069001']"
        :disabled="this.topData.statusFlag === '001' ? false : true"
        @click="handleSave('ZT03')"
        >{{ $t('prescriptionList.buttons.revert') }}</el-button
      >
      <!-- <el-button class="fixed-bottom-btn" type="primary" @click="handleValid('ZT06')">{{$t('prescriptionList.buttons.save')}}</el-button>
      <el-button class="fixed-bottom-btn" type="primary" @click="handleValid('ZT02')">{{$t('prescriptionList.buttons.submit')}}</el-button>
      <el-button class="fixed-bottom-btn" type="primary" @click="handleValid('ZT03')">{{$t('prescriptionList.buttons.upload')}}</el-button> -->
    </footer>
    <!-- 成本计算 -->
    <!-- <div class="prescriptionData">{{this.$t('prescriptionList.form.costingCost')}}</div> -->
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  // import DataBaseAPI from '@/api/dataBase';
  import API from '@/api/productCenter/prescriptionData';
  import { mapState } from 'vuex';
  import { dateFormat } from '@/filters';
  import { topDataRules } from './rules/rules';
  // import SearchTable from '@/components/form-item/search-table';
  // import SiruiSearch from '@/components/SiruiSearch';
  // import SiruiTable from '@/components/SiruiTable';
  // import inputNumber from '@/components/form-item/input-number';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  // import DictSelect from '@/components/DictSelect';
  // import collarAPI from '@/api/productCenter/collarDetails';
  // import upload from '@/components/upload';
  // import InputNumberAd from '@/components/form-item/input-number-advance';

  export default {
    name: 'prescriptionDataAdd',
    components: {
      baseForm,
      // SiruiTable,
      // SiruiSearch,
      // inputNumber,
      // DictSelect,
      // ajaxSelect,
      // SearchTable,
      // upload,
      // InputNumberAd,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        // 状态 => 用于表格回显
        requestStatusData(state) {
          let dictList = state.dict.dictList;
          if (dictList.length > 0) {
            return dictList.find((it) => it.dictType == 'request_status').dictList;
          } else {
            return [];
          }
        },
      }),
      routerData() {
        return this.$route.query;
      },
      // <!-- 顶部菜单-->
      options() {
        return [
          {
            type: 'input',
            label: this.$t('prescriptionList.label.companyName'),
            prop: 'companyName',
            required: true,
            disabled: true,
          },
          {
            type: 'input',
            label: this.$t('prescriptionList.label.departmentName'),
            prop: 'departmentName',
            required: true,
            disabled: true,
          },
          {
            type: 'input',
            label: this.$t('prescriptionList.label.createBy'),
            prop: 'createBy',
            required: true,
            disabled: true,
          },
          {
            type: 'date',
            label: this.$t('prescriptionList.label.gmtCreate'),
            prop: 'gmtCreate',
            placeholder: this.$t('placeholder.auto'),
            required: true,
            disabled: true,
          },
          //   配方编号
          {
            type: 'input',
            label: this.$t('prescriptionList.label.formulaNo'),
            prop: 'formulaNo',
            placeholder: this.$t('placeholder.auto'),
            required: true,
            disabled: true,
          },
          //   配方状态 001-已保存，002-已生效
          {
            type: 'dict',
            dictType: 'formula_status',
            label: this.$t('prescriptionList.label.statusFlag'),
            prop: 'statusFlag',
            placeholder: this.$t('placeholder.auto'),
            required: true,
            disabled: true,
          },
          //   配方用途
          {
            type: 'dict',
            dictType: 'formula_usage',
            label: this.$t('prescriptionList.label.formulaUsage'),
            prop: 'formulaUsage',
            required: false,
            disabled: this.topData.statusFlag === '001' ? true : false,
          },
        ];
      },
      /* options1() {
        const data = this.topData1;
        return [
        //   销售商品
          {
            type: 'searchTable', 
            label: this.$t('prescriptionList.label.productName'), 
            prop: 'productName',
            required: true, 
            disabled:this.topData.statusFlag==='001'?true:false,
            searchType: "produceProduct",
            isMultiple: true,
            extraData: {
              productStatus: '001'
            },
            currentValue: this.topData1.productName, //用于回显展示
          },
        //   商品编号
          {
            type: 'input', 
            label: this.$t('prescriptionList.label.productCode'), 
            prop: 'productCode',
            required: false, 
            disabled:true,

          },
          
          
      ]
    }, */
      options2() {
        return [
          //   大类
          {
            type: 'dict',
            dictType: 'formula_category',
            label: this.$t('prescriptionList.label.formulaCategory'),
            prop: 'formulaCategory',
            disabled: this.topData.statusFlag === '001' ? true : false,
          },
          //   规格型号
          {
            type: 'input',
            label: this.$t('prescriptionList.label.productModel'),
            prop: 'productModel',
            disabled: this.topData.statusFlag === '001' ? true : false,
          },
          //   花纹
          {
            type: 'input',
            label: this.$t('prescriptionList.label.figureType'),
            prop: 'figureType',
            disabled: this.topData.statusFlag === '001' ? true : false,
          },
          {
            type: '',
            prop: '',
          },
          //   重量
          {
            type: 'sixNumber',
            label: this.$t('prescriptionList.label.weight'),
            prop: 'weight',
            required: true,
            disabled: this.topData.statusFlag === '001' ? true : false,
            precision: this.$globalVar.pPoint,
            max: 999999999.999999,
            min: 0,
          },
          //   单位
          {
            type: 'dict',
            dictType: 'produce_basic_unit',
            label: this.$t('prescriptionList.label.basicUnit'),
            prop: 'basicUnit',
            required: true,
            disabled: true,
            //disabled:this.topData.statusFlag==='001'?true:false
          },
        ];
      },
      bottomOptions() {
        return [
          //  辅料成本(不含税)
          {
            type: 'amountNumber',
            label: this.$t('prescriptionList.label.auxiliaryMaterialCost'),
            prop: 'auxiliaryMaterialCost',
            span: 10,
            required: true,
            disabled: false,
          },
          {
            type: '',
            prop: '',
          },
          {
            type: '',
            prop: '',
          },

          //主原料成本(不含税)
          {
            type: 'amountNumber',
            label: this.$t('prescriptionList.label.rawMaterialCost'),
            prop: 'rawMaterialCost',
            span: 10,
            required: true,
            disabled: true,
            precision: this.$globalVar.aPoint,
            max: 999999999.999999,
            min: 0,
          },
          {
            type: '',
            prop: '',
          },
          {
            type: '',
            prop: '',
          },
          //加工费用(不含税)
          {
            type: 'amountNumber',
            label: this.$t('prescriptionList.label.processCost'),
            prop: 'processCost',
            span: 10,
            required: true,
            precision: this.$globalVar.aPoint,
            max: 999999999.999999,
            min: 0,
          },
          {
            type: '',
            prop: '',
          },
          {
            type: '',
            prop: '',
          },
          //单条成本
          {
            type: 'amountNumber',
            label: this.$t('prescriptionList.label.singleCost'),
            prop: 'singleCost',
            span: 10,
            required: true,
            disabled: true,
            precision: this.$globalVar.aPoint,
            max: 999999999.999999,
            min: 0,
          },
        ];
      },
      // <!-- 校准名称行项目表格 -->
      linkColumnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            type: 'seq',
            title: this.$t('prescriptionList.table.sortNo'),
            width: 80,
          },
          {
            field: 'materialCategory',
            title: this.$t('prescriptionList.table.materialCategory'),
            /* 自定义列为select组件样例 */
            editRender: {
              name: 'ElSelect',
              options: this.materialCategoryList,
              props: {
                clearable: true,
              },
              events: { change: (obj) => this.priceChange(obj.row, 'materialCategory') },
            },
            /* slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [<span>{row.materialCategory}</span>];
            },
            edit: ({ row }) => {
              return [
                <dict-select
                  placeholder={this.$t(
                    "prescriptionList.table.selectPlaceholder"
                  )}
                  type="material_category"
                  value={row["materialCategory"]}
                  onChange={(val, label) =>
                    this.handleChangeInput(val, label, row, "materialCategory")
                  }
                ></dict-select>
              ];
            }
          } */
          },
          //配料名称-原料名称
          {
            field: 'productName',
            title: this.$t('prescriptionList.table.materialDesc'),
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.productName}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="produceProduct"
                    isMultiple={true}
                    currentValue={row['productName']}
                    checkRowKeys={[row['productCode']]}
                    onInput={(val) => this.chooseTable(val, row)}
                    extraData={
                      row['materialCategory'] === '0'
                        ? {
                            productStatus: '001',
                            productClass: '0',
                            productType: row['materialCategory'],
                          }
                        : {
                            productStatus: '001',
                            productClass: '0',
                            productCategory: row['materialCategory'],
                          }
                    }
                  ></search-table>,
                ];
              },
            },
          },
          //配料编号-原料编号
          {
            field: 'productCode',
            title: this.$t('prescriptionList.table.productCode'),
            editRender: { name: 'ElInput', props: { clearable: true, disabled: true } },
          },
          {
            field: 'materialNumber',
            title: this.$t('prescriptionList.table.materialNumber'),
            editRender: { name: 'ElInput', default: '' },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.materialNumber}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['materialNumber']}
                    precision={this.$globalVar.pPoint}
                    max={999999999999.999999}
                    onInput={(val) => this.handleChangeNumber(val, row, 'materialNumber')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            field: 'basicUnit',
            title: this.$t('prescriptionList.table.basicUnit'),
            /* 自定义列为select组件样例 */
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('produce_basic_unit'),
              props: {
                clearable: true,
                disabled: true,
              },
              events: { change: (obj) => this.priceChange(obj.row, 'basicUnit') },
            },
            /* slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [<span>{row.basicUnit}</span>];
            },
            edit: ({ row }) => {
              return [
                <dict-select
                  placeholder={this.$t(
                    "prescriptionList.table.selectPlaceholder"
                  )}
                  type="produce_basic_unit"
                  value={row["basicUnit"]}
                  onChange={(val, label) =>
                    this.handleChangeInput(val, label, row, "basicUnit")
                  }
                ></dict-select>
              ];
            }
          } */
          },
          {
            field: 'addedDate',
            title: this.$t('prescriptionList.table.addedDate'),
            width: 200,
            editRender: {
              name: 'ElDatePicker',
              props: { clearable: true, valueFormat: 'yyyy-MM-dd' },
            },
          },
          {
            field: 'materialPrice',
            title: this.$t('prescriptionList.table.materialPrice'),
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.materialPrice)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['materialPrice']}
                    precision={this.$globalVar.pPoint}
                    max={999999999999.999999}
                    onInput={(val) => this.handleChangeNumber(val, row, 'materialPrice')}
                  ></input-number-ad>,
                ];
              },
            },
          },
        ];
      },
      // <!-- 销售规格行项目表格 -->
      columnList() {
        return [
          {
            type: 'seq',
            title: this.$t('prescriptionList.table.sortNo'),
            width: 80,
          },
          //销售商品
          {
            field: 'productName',
            title: this.$t('prescriptionList.label.productName'),
          },
          //商品编号-产品编号
          {
            field: 'productCode',
            title: this.$t('prescriptionList.label.productCode'),
          },
        ];
      },
      rules() {
        return {
          materialCategory: [
            {
              required: true,
              message: this.$t('prescriptionList.placeholderTable.materialCategory'),
            },
          ],
          productName: [
            {
              required: true,
              message: this.$t('prescriptionList.placeholderTable.productName'),
            },
          ],
          materialNumber: [
            {
              required: true,
              message: this.$t('prescriptionList.placeholderTable.materialNumber'),
            },
          ],
          basicUnit: [
            {
              required: true,
              message: this.$t('prescriptionList.placeholderTable.basicUnit'),
            },
          ],
          addedDate: [
            {
              required: true,
              message: this.$t('prescriptionList.placeholderTable.addedDate'),
            },
          ],
          materialPrice: [
            {
              required: true,
              message: this.$t('prescriptionList.placeholderTable.materialPrice'),
            },
          ],
        };
      },
    },
    data() {
      return {
        topDataRules: topDataRules,
        tableData: [],
        topTableData: [],
        formulaCategory: '',
        activeNames: ['1', '2', '3', '4', '5', '6'], //默认展开所有面板
        identification: [
          {
            label: this.$t('prescriptionList.label.redBack'),
            value: this.$t('prescriptionList.label.redBack'),
          },
        ],
        topData: {
          companyName: null, // 公司
          departmentName: null, // 部门
          createBy: null, // 创建人
          gmtCreate: null, // 创建日期
          formulaNo: null, // 配方编号
          statusFlag: null, // 配方状态 001-已生效,002-已保存
          formulaUsage: '001', // 配料用途 001-生产，002-试料，默认生产
        },
        /* topData1: {
        productCode: null,    // 商品编号
        productName: null,    // 商品名称
          
      }, */
        topData2: {
          formulaCategory: null, // 大类
          productModel: null, // 规格型号
          figureType: null, // 花纹
          weight: null, // 重量
          basicUnit: '001', // 基本单位 001-千克，002-吨，003-克
        },
        bottomData: {
          auxiliaryMaterialCost: 0, //辅料成本(不含税)
          rawMaterialCost: 0, //主原料成本(不含税)
          processCost: 0, //加工费用(不含税)
          singleCost: 0, //单条成本
        },
        addRowObj: {
          materialCategory: null,
          productName: null,
          formulaNo: null,
          materialNumber: null,
          basicUnit: '001',
          addedDate: dateFormat(new Date()),
          materialPrice: null,
        },
        tempWeight: null,
        selectIds: [], //选中删除的行项目
        //附件
        uploadTableData: [],
        materialCategoryList: this.$baseRequest.getDictListMapByType('produce_product_category'), //原料大类
        productTypeList: this.$baseRequest.getDictListMapByType('productType'), //主辅料
      };
    },
    mounted() {
      //配料类别=原料大类+辅料
      this.productTypeList.map((item) => {
        if (['0'].indexOf(item.value) != -1 && !this.materialCategoryList.includes(item)) {
          this.materialCategoryList.unshift(item);
        }
      });

      if (this.$route.name.indexOf('Add') != -1) {
        ['companyCode', 'companyName', 'departmentCode', 'departmentName'].map((item) => {
          this.topData[item] = this.userInfo[item];
        });
        this.topData.createBy = this.userInfo.userName;
      }
      this.getDictList();
      if (this.$route.query.id) {
        this.getData();
      }
      this.getOssUrl();
    },

    methods: {
      priceChange(row, field) {
        if (field == 'materialCategory') {
          row.productCode = null;
          row.productName = null;
        }
        this.handleChangeBottomData();
      },
      //获取值
      chooseTable(val, row) {
        row.productName = val[0].productName;
        row.productCode = val[0].productCode;
        // 实时更新数据
        this.updateData();
        this.handleChangeBottomData();
      },
      // 在值发生改变时更新数据
      updateData() {
        let xTable = this.$refs.table;
        xTable.updateData();
      },
      buttonStatus() {
        return this.topData.statusFlag === '001' ? true : false;
      },
      // 表单变化
      handleChangeTopData(value, prop) {
        if (prop == 'supplierName') {
          this.searchPartner(value.supplierName);
        }
        if (prop == 'productName') {
          this.topData1.productCode = value.productName[0].productCode;
          this.topData1.productName = value.productName[0].productName;
        }
        if (prop == 'weight' || prop == 'basicUnit') {
          this.handleChangeBottomData();
        }
        //this.$forceUpdate()
      },
      async handleChangeBottomData(value, prop) {
        this.tempWeight = this.topData2.weight;
        if (this.tempWeight) {
          if (this.topData2.basicUnit == '002') {
            //吨
            this.tempWeight = this.$cal.calCommon(this.tempWeight, 1000, '*');
            //console.log("ton:"+materialNumberTemp);
          } else if (this.topData2.basicUnit == '003') {
            //克
            this.tempWeight = this.$cal.calCommon(this.tempWeight, 1000, '/');
            //console.log("gram:"+materialNumberTemp);
          } else {
            this.tempWeight = this.$cal.calCommon(this.tempWeight, 1, '*');
          }
        }
        //默认目前计算逻辑可修改
        if (prop != 'auxiliaryMaterialCost') {
          this.bottomData.auxiliaryMaterialCost = 0;
        }
        this.bottomData.rawMaterialCost = 0;
        //this.bottomData.processCost=0;
        this.bottomData.singleCost = 0;
        let materialNumberTemp = '';
        let sysFormulaDetails = await this.exportTableData();
        for (let item of sysFormulaDetails) {
          //console.log(item.materialCategory+"===="+item.basicUnit+"===="+item.materialNumber+"===="+item.materialPrice+"====");
          materialNumberTemp = 0;
          if (item.basicUnit == '002') {
            //吨
            materialNumberTemp = this.$cal.calCommon(item.materialNumber, 1000, '*');
            //console.log("ton:"+materialNumberTemp);
          } else if (item.basicUnit == '003') {
            //克
            materialNumberTemp = this.$cal.calCommon(item.materialNumber, 1000, '/');
            //console.log("gram:"+materialNumberTemp);
          } else {
            materialNumberTemp = this.$cal.calCommon(item.materialNumber, 1, '*');
          }

          if (item.materialCategory == '0' && prop != 'auxiliaryMaterialCost') {
            this.bottomData.auxiliaryMaterialCost = this.$cal.calCommon(
              this.bottomData.auxiliaryMaterialCost,
              this.$cal.calCommon(materialNumberTemp, item.materialPrice, '*'),
              '+'
            ); //辅料成本(不含税)
            //console.log("this.auxiliaryMaterialCost:"+this.bottomData.auxiliaryMaterialCost);
          } else {
            this.bottomData.rawMaterialCost = this.$cal.calCommon(
              this.bottomData.rawMaterialCost,
              this.$cal.calCommon(materialNumberTemp, item.materialPrice, '*'),
              '+'
            ); //主原料成本(不含税)
            //console.log("this.rawMaterialCost:"+this.bottomData.rawMaterialCost);
          }
        }

        let subSum = this.$cal.calCommon(
          this.bottomData.auxiliaryMaterialCost,
          this.bottomData.rawMaterialCost,
          '+'
        );
        this.bottomData.singleCost = this.$cal.calCommon(
          this.$cal.calCommon(subSum, this.bottomData.processCost, '+'),
          this.tempWeight,
          '*'
        );
      },
      handleChangeInput(val, label, row, type) {
        if (type == 'materialCategory') {
          row[type] = val;
          row.materialCategory = label;
          row.materialDesc = ' ';
          row.formulaNo = ' ';
          row.materialCategory = null;
          setTimeout(() => {
            row.materialCategory = label;
          }, 10);
        }
        if (type == 'productName') {
          row[type] = val.value;
          row.productName = val.label;
        }
        if (type == 'formulaNo') {
          row[type] = val.formulaNo;
          row.formulaNo = val.formulaNo;
        }
        if (type == 'basicUnit') {
          row[type] = val;
          row.basicUnit = null;
          setTimeout(() => {
            row.basicUnit = label;
            this.handleChangeBottomData();
          }, 10);
        }
      },
      handleChangeNumber(val, row, type) {
        row[type] = val;
        if (type == 'materialNumber' || type == 'materialPrice') {
          this.handleChangeBottomData();
        }
      },

      // 保存
      async handleSave(btnType) {
        // 保存时主数据状态为草稿，可以直接提交状态变为已生效，撤销已生效的数据状态为草稿，草稿或无无状态才可编辑修改
        if (btnType === 'ZT03') {
          //撤销
          if (this.topData.statusFlag === '002') {
            //001-已生效,002-已保存
            return;
          }
          const topTableDataGood = this.$refs.topTable.getTableData().fullData;
          if (topTableDataGood == 0) {
            this.topData.statusFlag = '002';
          } else {
            this.loading.startLoading();
            let params = { periodStatus: 'opened' };
            let res = await this.$axios.post(API.QUERY_PDPERIOD, params);
            if (res) {
              this.loading.endLoading();
              if (res.data.code == 0) {
                if (res.data.data.length == 1) {
                  this.topData.statusFlag = '002';
                } else {
                  this.$message({
                    showClose: true,
                    message: this.$t('prescriptionList.message.periodMoreThenOne'),
                    type: 'error',
                  });
                }
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            }
          }
          return;
        }
        //let params = Object.assign(this.topData,this.topData,this.topData);
        let topBaseData = this.exportBaseData(btnType);
        let bottomBaseData = this.exportBottomData(btnType);
        topBaseData = this.$baseRequest.assignObj(topBaseData);
        topBaseData = Object.assign(topBaseData, bottomBaseData);
        //let sysFormulaDetails = this.$refs.prescriptionData.getTableData().fullData;
        let sysFormulaDetails = await this.exportTableData();

        //附件信息
        {
          /* const attachment = that.uploadTableData.map((item, index) => {
          const result = Object.assign(
            {},
            {
              sortNo: index,
            },
            item
          );
          return result;
        }); */
        }
        let params = {};
        if (topBaseData && sysFormulaDetails && bottomBaseData) {
          topBaseData.createBy = this.userInfo.userCode;
          //附件信息
          //topBaseData.attachmentList = attachment;
          params = {
            ...topBaseData,
            sysFormulaDetails,
          };
          if (this.$route.query.id) {
            params = {
              ...params,
              id: this.$route.query.id,
              delDetailsIds: this.selectIds,
            };
          }
          this.loading.startLoading();
          let res = await this.$axios.post(API.ADD_FORMULA, params);
          if (res) {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                message: this.$t('message.saveSussess'),
                type: 'success',
              });
              this.toList();
            } else {
              this.topData.statusFlag = '002';
              this.topData.createBy = this.userInfo.userName;
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          }
        }

        /* this.$axios.post(API.ADD_FORMULA, params).then(res => {
        this.loading.endLoading();
        if(res.data.code === 0) {
          this.$message({
              showClose: true,
              message: this.$t("prescriptionList.message.saveSuccess"),
              type: "success"
            });
            this.$baseRequest.linkBackRouteUrl(
              "/productionCenter/prescriptionDataAdd",
              "prescriptionDataAdd",
              "",
              "/productionCenter/prescriptionDataList",
              "prescriptionDataList",
              ""
            );
        } else {
          this.$message({ showClose: true, message: res.data.msg, type: "error" });
        }
      }) */
      },
      //跳转
      toList() {
        let pathList = {
          fromPath: {
            path: '/production/prescriptionDataAdd',
            name: 'prescriptionDataAdd',
            meta: {
              keepAlive: true,
              title: this.$t('prescriptionList.pages.prescriptionDataAdd'),
            },
          },
          toPath: {
            path: '/production/prescriptionDataList',
            name: 'prescriptionDataList',
            meta: {
              keepAlive: false,
              title: this.$t('prescriptionList.pages.prescriptionDataList'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
      handleValid(type) {
        if (type === 'ZT06') {
          // 顶部表单校验
          const topDataValid = new Promise((resolve, reject) => {
            this.$refs.topData.$refs.ruleForm
              .validate((valid) => {
                if (valid) {
                  resolve(this.topData);
                } else {
                  reject();
                }
              })
              .catch(() => {});
          });
          // 表格校验
          const prescriptionData = new Promise((resolve, reject) => {
            this.$refs.prescriptionData
              .validate((valid) => {
                if (valid) {
                  this.handleSave(2222);
                  resolve(this.baseData.prescriptionData);
                } else {
                  reject();
                  this.$message({ showClose: true, type: 'error', message: '请将表格填写完整' });
                }
              })
              .catch(() => {});
          });
          const list = [topDataValid, prescriptionData];
          Promise.all(list).then((result) => {
            // 校验通过
            this.handleSave(result, type);
          }).catch;
        }
      },
      // 返回表单数据
      exportBaseData(btnType) {
        this.topData.statusFlag = '002';
        if (btnType == 'ZT02') {
          let sign = false;

          /* this.$refs.topData1.$refs.ruleForm.validate(valid => {
          if (valid) {
            
            sign = true;
          } else {
            sign = false;
          }
        }); */

          this.$refs.topData2.$refs.ruleForm.validate((valid) => {
            if (valid) {
              this.topData.statusFlag = '001'; //001-已生效，002-已保存
              sign = true;
            } else {
              sign = false;
            }
          });

          return sign ? Object.assign({}, this.topData, this.topData2) : false;
        } else {
          return Object.assign({}, this.topData, this.topData2);
        }
      },
      // 返回底部表单数据
      exportBottomData(btnType) {
        this.topData.statusFlag = '002';
        if (btnType == 'ZT02') {
          let sign = false;

          this.$refs.bottomData.$refs.ruleForm.validate((valid) => {
            if (valid) {
              this.topData.statusFlag = '001'; //001-已生效，002--已保存
              sign = true;
            } else {
              sign = false;
            }
          });
          return sign ? Object.assign({}, this.bottomData) : false;
        } else {
          return Object.assign({}, this.bottomData);
        }
      },
      // 返回表格数据
      exportTableData() {
        const tableData = this.$refs.table.getTableData().fullData;
        if (tableData.length == 0) {
          return [];
        } else {
          return new Promise((resolve) => {
            this.$refs.table.validate().then(() => {
              resolve(tableData);
            });
          });
        }
      },
      // 载具表格新增一行
      insertEvent(row) {
        this.$refs.table.validate().then(() => {
          let record = JSON.parse(JSON.stringify(this.addRowObj));
          this.$refs.table.insertAt(record, row).then(({ row }) => {
            this.$refs.table.setActiveRow(row);
          });
        });
      },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('prescriptionList.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            for (let item of selectedList) {
              this.selectIds.push(item.id);
            }
            this.$refs[tableTpye].removeSelecteds();
            this.updateData();
            this.handleChangeBottomData();
            //this.baseData[tableTpye] = this.$refs[tableTpye].getTableData().fullData;
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('prescriptionList.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('prescriptionList.message.cancelled'),
            });
          });
      },
      // 获取字典值
      getDictList() {},
      // 初始化数据
      getData() {
        /* this.topData.companyName = this.userInfo.companyName;
      this.topData.departmentName = this.userInfo.departmentName;
      this.topData.createBy = this.userInfo.userName; */
        if (this.$route.query.id) {
          //修改界面
          let params = {
            id: this.routerData.id,
          };
          this.loading.startLoading();
          this.$axios.post(API.DETAIL_FORMULA, params).then((res) => {
            this.loading.endLoading();
            if (res.data.code == 0) {
              let allDetail = res.data.data;
              this.tableData = allDetail.sysFormulaDetails;
              this.topTableData = allDetail.pdProductList;

              let [basicInfo, basicInfo2, bottombasicInfo] = [
                this.topData,
                this.topData2,
                this.bottomData,
              ];

              let [basicKeys, basicKeys2, bottombasicKeys] = [
                Object.keys(basicInfo),
                Object.keys(basicInfo2),
                Object.keys(bottombasicInfo),
              ];

              basicKeys.map((item) => {
                basicInfo[item] = allDetail[item];
              });
              basicKeys2.map((item) => {
                basicInfo2[item] = allDetail[item];
              });
              bottombasicKeys.map((item) => {
                bottombasicInfo[item] = allDetail[item];
              });
              this.$baseRequest.getPerson().then((res) => {
                basicInfo.createBy = res.find((item) => item.id == basicInfo.createBy).personName;
              });
            }
          });
        }
      },
      //上传回调
      handleUpload(uploadTableData) {
        this.uploadTableData = uploadTableData;
      },
      getOssUrl() {},

      baseData() {},
    },
  };
</script>
<style scoped>
  .el-row {
    margin-bottom: 20px;
  }
  .el-col {
    border-radius: 4px;
  }
  .lableStyle >>> .el-form-item--small.propClass .el-form-item__label {
    line-height: 32px !important;
  }
</style>
